import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { AuraBaseDesignTokens } from '@primeng/themes/aura/base';
import { Preset } from '@primeng/themes/types';

const customOverrides: Preset<AuraBaseDesignTokens> = {
    primitive: {
        lime: {
            50: '#f0faeb',
            100: '#def3d4',
            200: '#bfe8ae',
            300: '#97d87e',
            400: '#74c556',
            500: '#4fa034',
            600: '#3f8729',
            700: '#326823',
            800: '#2b5321',
            900: '#274720',
            950: '#11260d',
        },
    },
    semantic: {
        colorScheme: {
            light: {
                surface: {
                    50: '{neutral.50}',
                    100: '{neutral.100}',
                    200: '{neutral.200}',
                    300: '{neutral.300}',
                    400: '{neutral.400}',
                    500: '{neutral.500}',
                    600: '{neutral.600}',
                    700: '{neutral.700}',
                    800: '{neutral.800}',
                    900: '{neutral.900}',
                    950: '{neutral.950}',
                },
            },
        },
        primary: {
            50: '{lime.50}',
            100: '{lime.100}',
            200: '{lime.200}',
            300: '{lime.300}',
            400: '{lime.400}',
            500: '{lime.500}',
            600: '{lime.600}',
            700: '{lime.700}',
            800: '{lime.800}',
            900: '{lime.900}',
            950: '{lime.950}',
        },
    },
    components: {
        inputtext: {
            root: {
                borderRadius: '8px',
                borderColor: 'rgba(0,0,0,.1)',
                hoverBorderColor: 'rgba(0,0,0,.25)',
                focusBorderColor: '{lime.500}',
                placeholderColor: 'rgba(0,0,0,.3)',
                invalidBorderColor: '{rose.500}',
                invalidPlaceholderColor: '{rose.500}',
                lg: {
                    fontSize: '16px',
                    paddingX: '17px',
                    paddingY: '13px',
                },
                focusRing: {
                    width: '4px',
                    style: 'solid',
                    color: '{lime.50}',
                },
            },
        },
        textarea: {
            root: {
                borderRadius: '8px',
                borderColor: 'rgba(0,0,0,.1)',
                hoverBorderColor: 'rgba(0,0,0,.25)',
                focusBorderColor: '{lime.500}',
                placeholderColor: 'rgba(0,0,0,.3)',
                invalidBorderColor: '{rose.500}',
                invalidPlaceholderColor: '{rose.500}',
                lg: {
                    fontSize: '16px',
                    paddingX: '17px',
                    paddingY: '13px',
                },
                focusRing: {
                    width: '4px',
                    style: 'solid',
                    color: '{lime.50}',
                },
            },
        },
        select: {
            root: {
                borderRadius: '8px',
                borderColor: 'rgba(0,0,0,.1)',
                hoverBorderColor: 'rgba(0,0,0,.25)',
                focusBorderColor: '{lime.500}',
                placeholderColor: 'rgba(0,0,0,.3)',
                invalidBorderColor: '{rose.500}',
                invalidPlaceholderColor: '{rose.500}',
                lg: {
                    fontSize: '16px',
                    paddingX: '17px',
                    paddingY: '13px',
                },
                focusRing: {
                    width: '4px',
                    style: 'solid',
                    color: '{lime.50}',
                },
            },
        },
        button: {
            root: {
                borderRadius: '8px',
                lg: {
                    fontSize: '16px',
                    paddingX: '18px',
                    paddingY: '13px',
                },
                label: {
                    fontWeight: 'bold',
                },
            },
            colorScheme: {
                light: {
                    root: {
                        primary: {
                            background: '{neutral.950}',
                            borderColor: '{neutral.950}',
                            hoverBackground: '{neutral.800}',
                            hoverBorderColor: '{neutral.800}',
                            activeBackground: '{neutral.950}',
                            activeBorderColor: '{neutral.950}',
                        },
                        success: {
                            background: '{lime.500}',
                            borderColor: '{lime.500}',
                            hoverBackground: '{lime.600}',
                            hoverBorderColor: '{lime.600}',
                            activeBackground: '{lime.600}',
                            activeBorderColor: '{lime.600}',
                        },
                    },
                },
            },
        },
        message: {
            root: {
                borderRadius: '10px',
            },
            colorScheme: {
                light: {
                    error: {
                        background: '{rose.50}',
                        borderColor: '{rose.500}',
                        color: '{rose.600}',
                    },
                },
            },
        },
    },
};

export const preset: Preset = definePreset(Aura, customOverrides);
